import React, {useEffect, useState} from 'react'
import { Button } from '../common';
import SubscriptionModal from './SubscriptionModal';
import { formatMoney } from '../../utils';
import { isLoading } from '../core/InfoCard/InfoCard.stories';

interface SubscriptionBoxProps{
    title: string;
    limits: any;
    price: number;
    isPopular: boolean;
    Level: string[];
    index: number;
    show: (plan:string, price: number) => void;
    isChoosing:boolean;
}

const SubscriptionBox = ({title, price, isPopular, Level, index, show, limits, isChoosing}: SubscriptionBoxProps) => {

  return (
    <>
    <div className='flex flex-col items-center '>
      <div className='w-[306px] h-fit  bg-[#Fff] shadow-md rounded-md '>
        <div className='flex flex-col text-center items-center'>

        <div className='text-white flex flex-row items-center  pt-[52px]'>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="12" fill="#109EC9"/>
           <path d="M14 17L17.5561 20.8794C17.6155 20.9442 17.7178 20.9442 17.7772 20.8794L25 13" stroke="#FF6702" stroke-width="2"/>
            <path d="M29.5 18C29.5 20.2745 28.8255 22.4979 27.5619 24.3891C26.2983 26.2802 24.5022 27.7542 22.4009 28.6246C20.2995 29.495 17.9872 29.7228 15.7565 29.279C13.5257 28.8353 11.4766 27.74 9.86827 26.1317C8.25997 24.5234 7.1647 22.4743 6.72097 20.2435C6.27724 18.0128 6.50498 15.7005 7.37539 13.5991C8.24579 11.4978 9.71978 9.70174 11.6109 8.4381C13.5021 7.17446 15.7255 6.5 18 6.5" stroke="#044E97" stroke-linecap="round"/>
        </svg>
          <p className='text-[#2B2B2B] text-[20px]' style={{fontWeight: 700}}>{title} <span className='text-[#979797] text-[20px]' style={{fontWeight: 400}}>Plan</span> </p> 
        </div>

          <div className='flex flex-col px-[27px] py-[45px]'>
            {Object.entries(limits).map((feature:any, index:any) => {
                return (
                    <div className={`flex flex-row space-x-[23px] ${index === 4 ? "pt-[10px]": "py-[10px]"} flex-1 items-center`}>
                      <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                      <path d="M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19Z" fill="white"/>
                      <path d="M9.5 18.5C14.4706 18.5 18.5 14.4706 18.5 9.5C18.5 4.52944 14.4706 0.5 9.5 0.5C4.52944 0.5 0.5 4.52944 0.5 9.5C0.5 14.4706 4.52944 18.5 9.5 18.5Z" stroke="#5064CC"/>
                       <path d="M4.49982 10.0498L7.23615 13.2349L14.1815 6.5" stroke="#5064CC"/>
                     </svg>
                      </div>
                      <div>
                        {feature[1]}  {feature[0]}
                    </div>
                    </div>
                )
           })}
          </div>

          <div className='text-center space-y-[24px] pb-[31px]'>
          <p className=' text-[#979797] lg:text-[16px]'><span style={{fontWeight: 600}} className='lg:text-[30px] text-[#000]'>{formatMoney(price)}</span>/Month</p> 
          
         <div className='px-[10px] text-[10px] md:text-[16px]'>
         <Button onClick={() => show(title, price)} disabled={isChoosing} size='full' variant={`${index % 2 === 0 ? "secondary": "primary"}`}>{Level[index]}</Button>   
        </div>
        </div>

        </div>
       </div>

    {isPopular && 

    <div  className='hidden lg:block lg:w-[394px] py-[20px] bg-[#FFF4C6] text-center rounded-[12px] absolute bottom-[-4em]'>
     <div
     className="auth-arrow top-[-15%] left-[12em] absolute w-[32px] h-[28px] bg-[#FFF4C6]"
      style={{ clipPath: 'polygon(50% 0%, 100% 100%, 0% 100%)' }}
      ></div>
       <p>This is the most Popular Plan</p>
    </div>}
    </div>
    
    </>
    
  )
}

export default SubscriptionBox